/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { JsonCompat } from '../../compat/JsonCompat';
import { NodeCompat } from '../../compat/NodeCompat';
import { RegexCompat } from '../../compat/RegexCompat';
import { Extension } from '../../core/models/Extension';

/**
 * @author eric.wittmann@gmail.com
 * @class
 */
export class ModelUtils {
    /**
     * Returns true if the given object is null or undefined.  Obviously Java does not have the concept
     * of "undefined" but this must also support the case where this code is running in Javascript.
     * @param {*} object
     * @return {boolean}
     */
    public static isNullOrUndefined(object : any) : boolean {
        return NodeCompat.isNullOrUndefined(object);
    }

    /**
     * The opposite of isNullOrUndefined.
     * @param {*} object
     * @return {boolean}
     */
    public static isDefined(object : any) : boolean {
        return NodeCompat.isDefined(object);
    }

    /**
     * Detects the appropriate path parameter names from a path.  For example, if the
     * string "/resources/{fooId}/subresources/{barId}" is passed in, the following
     * string array will be returned:  [ "fooId", "barId" ]
     * @param {string} path
     * @return {string[]}
     */
    public static detectPathParamNames(path : string) : Array<string> {
        let paramNames : Array<string> = <any>([]);
        let matches : Array<string[]> = RegexCompat.findMatches(path, "\\{([^\\}]+)\\}");
        for(let index121=0; index121 < matches.length; index121++) {
            let match = matches[index121];
            {
                let name : string = match[1];
                /* add */(paramNames.push(name.trim())>0);
            }
        }
        return paramNames;
    }

    public static marshalExtension(extension : Extension) : any {
        let wrapper : any = JsonCompat.objectNode();
        JsonCompat.setProperty(wrapper, extension.name, extension.value);
        return wrapper;
    }

    public static unmarshalExtension(oldExtension : any, extension : Extension) {
        let name : string = /* get */JsonCompat.keys(oldExtension)[0];
        let value : any = JsonCompat.getPropertyObject(oldExtension, name);
        extension.name = name;
        extension.value = value;
    }
}
ModelUtils["__class"] = "io.apicurio.datamodels.cmd.util.ModelUtils";



